import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { initBlock, resetBlock } from './AddonsBlockSlice';

//pages
import SubscribersPage from './Pages/SubscribersPage/SubscribersPage';
import ServicePage from './Pages/ServicePage/ServicePage';
import MeshPage from './Pages/MeshPage/MeshPage';
import TechnicianPage from './Pages/TechnicianPage/TechnicianPage';
import InternetSpeedPage from './Pages/InternetSpeedPage/InternetSpeedPage';
import ErrorPage from './Pages/ErrorPage/ErrorPage';
import SuccessPage from './Pages/SuccessPage/SuccessPage';

//import authenticationProvider from '../../../utilities/authentication/authenticationProvider';

const Addons = (props) => {
    let currentView = null;

    // useEffect(() => {
    //     if (props.authentication.isAuthenticateFinish) {
    //         //if not isFullAuthenticated and not isOtpExtendedAuthenticated - redirect to login
    //         if (props.authentication.loginData.isFullAuthenticated || props.authentication.loginData.isOtpExtendedAuthenticated) {
    //             props.initBlock({ addonsBlock: props.iContent });
    //         }
    //         else {
    //             authenticationProvider.redirectToLogin(location.pathname, location.pathname);
    //         }
    //     }
    // }, [props.authentication.isAuthenticateFinish]);

    useEffect(() => {
        props.initBlock({ addonsBlock: props.iContent });
        return () => {
            props.resetBlock();
        }
    }, []);

    switch (props.page) {
        case 'subscribersPage': currentView = <SubscribersPage />; break;
        case 'servicePage': currentView = <ServicePage />; break;
        case 'meshPage': currentView = <MeshPage />; break;
        case 'technicianPage': currentView = <TechnicianPage />; break;
        case 'internetSpeedPage': currentView = <InternetSpeedPage />; break;
        case 'errorPage': currentView = <ErrorPage />; break;
        case 'successPage': currentView = <SuccessPage />; break;
    }

    return (
        <div className='page-content'>
            {currentView}
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        page: state.addonsBlock.page,
        addonId: state.addonsBlock.addonId,
        //authentication: state.authentication,
    };
};

const mapDispatchToProps = { initBlock, resetBlock };

export default connect(mapStateToProps, mapDispatchToProps)(Addons);
